export default function Services() {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Creación de LLC',
      description: 'Te ayudamos a registrar tu empresa en Estados Unidos de forma rápida y sencilla para que puedas comenzar tu negocio legalmente.',
      color: 'bg-blue-500'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Obtención de EIN',
      description: 'Gestionamos tu número de identificación fiscal (EIN) para que tu empresa pueda operar, abrir cuentas bancarias y pagar impuestos correctamente.',
      color: 'bg-green-500'
    },
    {
      icon: 'ri-car-line',
      title: 'Registro de vehículos y placas',
      description: 'Te ayudamos con el proceso de registro de vehículos y obtención de placas en Kentucky.',
      color: 'bg-teal-500'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Reparación de crédito',
      description: 'Te orientamos para mejorar tu crédito y abrir nuevas oportunidades financieras.',
      color: 'bg-indigo-500'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Créditos para negocios',
      description: 'Asesoría para obtener financiamiento y ayudar a que tu empresa crezca.',
      color: 'bg-emerald-500'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Asesoría para emprendedores',
      description: 'Apoyo para personas que quieren iniciar su negocio y no saben por dónde empezar.',
      color: 'bg-cyan-500'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos soluciones completas para ayudarte a establecer y hacer crecer tu negocio en Estados Unidos
          </p>
          <div className="w-24 h-1 bg-blue-600 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white rounded-lg p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:-translate-y-2"
            >
              <div className={`w-16 h-16 ${service.color} rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}